import BaseStore from '../../../components/BaseStore'

import numberToCN from '../../../utils/numberToCN'
import {AUDIT_COMMIT, AUDIT_DATA_LIST_CHANGED, AUDIT_ITEM_CLICK, SHOW_AUDIT_MAIN} from './EventKeys'

export default {
  name: 'BaseAuditDevice',
  extends: BaseStore,
  props: {
    maxAuditStage: {
      required: true,
      type: Number
    },
    query: {
      required: true,
      type: Object
    },
    importanceDeviceStatus: {
      type: Array
    }
  },
  data () {
    return {
      isShow: false,
      site: null,
      auditSiteDevice: null,
      stage: 0,
      conditions: {
        auditTime: this.query.auditTime,
        beginTime: new Date(this.query.auditTime).format('YYYY/MM/DD 00:00:00'),
        endTime: new Date(this.query.auditTime).format('YYYY/MM/DD 23:59:59'),
        isMultipleIntegral: true
      },
      recordTime: {},
      dataList: [],
      dataTimes: [],
      siteDeviceFactors: [],
      selectedFactorIds: [],
      auditRuleCategories: [],
      remark: null
    }
  },
  computed: {
    // loadAuditRuleCategories: () => false,
    numberToCN: () => numberToCN,
    hasAuditBtn () {
      return (1 << (this.stage - 1)) & (this.auditSiteDevice || {}).auditStage
    },
    siteDeviceCategory: () => 0,
    importanceDevicesMap () {
      if (!this.importanceDeviceStatus.length) {
        return {}
      }
      return this.importanceDeviceStatus.reduce((map, el) => {
        if (!map[el.siteDeviceId]) {
          map[el.siteDeviceId] = []
        }
        map[el.siteDeviceId].push(el)
        return map
      }, {})
    },
    importanceDeviceStatusMap () {
      if (!this.importanceDeviceStatus.length) {
        return {}
      }
      return this.importanceDeviceStatus.reduce((map, el) => {
        map[el.deviceStatusId] = el
        return map
      }, {})
    },
    startDatePickerOptions () {
      return {
        disabledDate: time => this.conditions.endTime && time.getTime() > new Date(this.conditions.endTime)
      }
    },
    endDatePickerOptions () {
      return {
        disabledDate: time => this.conditions.beginTime && time.getTime() < new Date(this.conditions.beginTime)
      }
    }
  },
  methods: {
    onGetSiteDeviceFactor (siteDeviceFactors) {},
    formatDataList (dataList) {
      throw new Error(`Must implement the 'formatDataList' method`)
    },
    onAuditItemClick ({site, siteDevice, stage}) {
      let {siteDeviceCategory} = this
      let {deviceCategoryId} = siteDevice

      let max = 1 << 30

      if (deviceCategoryId > max) {
        deviceCategoryId = (deviceCategoryId / max) | 0
        siteDeviceCategory = (siteDeviceCategory / max) | 0
      }

      if (!(siteDeviceCategory & deviceCategoryId)) {
        return
      }

      let {auditTime} = this.query

      this.site = site
      this.auditSiteDevice = siteDevice
      this.stage = stage
      this.isShow = true
      this.conditions.auditTime = auditTime
      if (stage !== -1 >>> 1) {
        this.conditions.beginTime = new Date(auditTime).format('YYYY/MM/DD 00:00:00')
        this.conditions.endTime = new Date(this.query.auditTime).format('YYYY/MM/DD 23:59:59')
        this.recordTime = {
          beginTime: new Date(auditTime).format('YYYY/MM/DD 00:00:00'),
          endTime: new Date(this.query.auditTime).format('YYYY/MM/DD 23:59:59')
        }
      } else {
        let date = new Date(auditTime)
        let year = date.getFullYear()
        let month = date.getMonth()
        this.conditions.beginTime = new Date(year, month, 1).format('YYYY/MM/DD 00:00:00')
        this.conditions.endTime = new Date(year, month + 1, 0).format('YYYY/MM/DD 23:59:59')
        this.recordTime = {
          beginTime: new Date(year, month, 1).format('YYYY/MM/DD 00:00:00'),
          endTime: new Date(year, month + 1, 0).format('YYYY/MM/DD 23:59:59')
        }
      }
      this.selectedFactorIds = []

      let siteDeviceId = siteDevice.id

      this.changeLoadStatus(true)

      let profileSiteDevice = this.profileSiteDevices.find(siteDevice => siteDevice.id === siteDeviceId)

      if (!profileSiteDevice) {
        return
      }

      let {siteDeviceFactors} = profileSiteDevice
      this.onGetSiteDeviceFactor(this.siteDeviceFactors = Object.freeze(siteDeviceFactors.filter(({status}) => status)))

      let promises = []

      // if (this.loadAuditRuleCategories) {
      promises.push(this.$api.AuditRuleCategory.getBySiteDeviceId(siteDevice.id))
      // }

      let query = {
        beginTime: this.conditions.beginTime,
        endTime: this.conditions.endTime,
        isMultipleIntegral: this.conditions.isMultipleIntegral,
        stage: stage
      }

      promises.push(this.$api.Audit.getAuditDataBySiteDevice(siteDeviceId, query))

      Promise.all(promises).then(data => {
        // if (this.loadAuditRuleCategories) {
        let [auditRuleCategories] = data

        auditRuleCategories = auditRuleCategories.map(auditRuleCategory => Object.freeze({
          id: auditRuleCategory.id,
          name: auditRuleCategory.name.replace(/规则$/, ''),
          flags: auditRuleCategory.flags,
          chartType: 'miniChart'
        }))

        auditRuleCategories.unshift({
          id: 'NULL',
          name: '数据缺失',
          flags: ['NULL']
        })

        auditRuleCategories.push(Object.freeze({
          id: 'FlagException',
          name: '标志位异常',
          flags: ['X']
        }))

        this.auditRuleCategories = Object.freeze(auditRuleCategories)
        // }

        this.formatDataList(data[data.length - 1])
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })

      let {auditId} = siteDevice

      this.remark = null

      if (auditId) {
        this.$api.Audit.getDetail(auditId).then(audit => {
          this.remark = audit.remark
        }).catch(console.error)
      }
    },
    getChangeAuditStageParam () {
      return {
        auditTime: this.conditions.auditTime,
        siteDeviceId: this.auditSiteDevice.id,
        stage: 1 << (this.stage - 1),
        remark: this.remark
      }
    },
    onMonthAuditSubmitBtnClick () {
      let {site, auditSiteDevice, conditions} = this
      let query = {
        siteDeviceId: auditSiteDevice.id,
        auditMonthTime: new Date(conditions.auditTime).format('YYYY/MM'),
        siteId: site.id
      }
      this.changeLoadStatus(true)

      this.$api.Audit.saveMonthAudit(query).then(data => {
        if (data) {
          this.$eventBus.emit(AUDIT_COMMIT)
          this.$eventBus.emit(SHOW_AUDIT_MAIN)
          this.isShow = false
        }
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onMonthAuditBtnClick () {
      let auditTime = JSON.parse(JSON.stringify(this.conditions.auditTime))
      let query = {
        siteDeviceId: this.auditSiteDevice.id,
        auditMonthTime: new Date(auditTime).format('YYYY/MM/DD 00:00:00')
      }
      let date = new Date(auditTime)
      let year = date.getFullYear()
      let month = date.getMonth()
      this.conditions.beginTime = new Date(year, month, 1).format('YYYY/MM/DD 00:00:00')
      this.conditions.endTime = new Date(year, month + 1, 0).format('YYYY/MM/DD 23:59:59')
      this.changeLoadStatus(true)

      this.$api.Audit.checkMonthAudit(query).then(data => {
        if (data) {
          this.recordTime = {
            beginTime: new Date(year, month, 1).format('YYYY/MM/DD 00:00:00'),
            endTime: new Date(year, month + 1, 0).format('YYYY/MM/DD 23:59:59')
          }
          this.onAuditTimeChanged()
        }
      }).catch(() => {
        this.conditions = Object.assign(this.conditions, {auditTime: new Date(this.recordTime.beginTime).format('YYYY/MM/DD'), ...this.recordTime})
      }).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onAuditTimeChanged (key) {
      if (key === 'range') {
        this.conditions = {
          ...this.conditions,
          beginTime: new Date(this.conditions.beginTime).format('YYYY/MM/DD 00:00:00'),
          endTime: new Date(this.conditions.endTime).format('YYYY/MM/DD 23:59:59')
        }
      } else {
        this.conditions = {
          ...this.conditions,
          beginTime: new Date(this.conditions.auditTime).format('YYYY/MM/DD 00:00:00'),
          endTime: new Date(this.conditions.auditTime).format('YYYY/MM/DD 23:59:59')
        }
      }
      let defectData = this.auditSiteDevice.dataHarvestRates ? this.auditSiteDevice.dataHarvestRates.filter(el => el.harvestRate === 0) : []
      this.getAuditSiteDevices()
      this.getAuditDataBySiteDevice()
      this.getRatio(defectData)
      this.tabChange({name: this.tabActiveName})
    },
    getRatio () {
      let {auditSiteDevice, conditions} = this
      this.changeLoadStatus(true)
      this.$api.Audit.getRatio(auditSiteDevice.id, conditions.auditTime).then(data => {
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    getAuditSiteDevices () {
      this.$api.Audit.getAuditSiteDevices({
        siteId: this.site.id,
        auditTime: new Date(this.conditions.auditTime).format('YYYY/MM/DD')
      }).then(auditSiteDevices => {
        let siteDeviceId = this.auditSiteDevice.id
        let auditSiteDevice = auditSiteDevices.find(siteDevice => siteDevice.id === siteDeviceId)

        if (!Number.isFinite(auditSiteDevice.auditStage)) {
          auditSiteDevice.auditStage = 1
        }

        auditSiteDevice.name = this.auditSiteDevice.name

        this.auditSiteDevice = Object.freeze(auditSiteDevice)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    getAuditDataBySiteDevice () {
      if (!this.isShow) {
        return
      }

      let {auditSiteDevice, conditions, stage} = this
      let query

      if (stage === -1 >>> 1) {
        let date = new Date(conditions.auditTime)
        let year = date.getFullYear()
        let month = date.getMonth()
        query = {
          beginTime: new Date(year, month, 1).format('YYYY/MM/DD 00:00:00'),
          endTime: new Date(year, month + 1, 0).format('YYYY/MM/DD 23:59:59'),
          isMultipleIntegral: conditions.isMultipleIntegral,
          stage: stage
        }
      } else {
        query = {
          beginTime: conditions.beginTime,
          endTime: conditions.endTime,
          isMultipleIntegral: conditions.isMultipleIntegral,
          stage: stage
        }
      }

      this.changeLoadStatus(true)

      this.$api.Audit.getAuditDataBySiteDevice(auditSiteDevice.id, query).then(dataList => {
        this.recordTime = {
          beginTime: conditions.beginTime,
          endTime: conditions.endTime
        }
        this.formatDataList(dataList)
        this.$nextTick(() => {
          this.$eventBus.emit(AUDIT_DATA_LIST_CHANGED, this.selectedFactorIds)
        })
      }).catch(() => {
        this.conditions = Object.assign(conditions, this.recordTime)
      }).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onBackBtnClick () {
      if (this.tabOpts) {
        let tabOpts = this.tabOpts
        this.tabActiveName = tabOpts[tabOpts.length - 1].name
      }
      this.isShow = false
      this.$eventBus.emit(SHOW_AUDIT_MAIN)
      this.dataList = []
      this.dataTimes = []
    },
    onBackReAuditBtnClick (errMsg) {
      this.$confirm(`是否继续退回上一级审核操作？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'confirm-dialog-confirm-btn',
        cancelButtonClass: 'confirm-dialog-cancel-btn',
        type: 'warning'
      }).then(() => {
        this.$eventBus.emit(SHOW_AUDIT_MAIN)
        this.backReAudit(errMsg)
      }).catch(() => {})
    },
    backReAudit (errMsg) {
      this.changeLoadStatus(true)

      this.$api.Audit.backReAudit({...this.getChangeAuditStageParam(), remark: errMsg}).then(data => {
        if (data) {
          this.$eventBus.emit(AUDIT_COMMIT)
          this.isShow = false
          this.$eventBus.emit(SHOW_AUDIT_MAIN)
        }
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    submitAudit () {
      // 可能有问题 赵大师的bug
      this.$eventBus.emit(SHOW_AUDIT_MAIN)
      this.changeLoadStatus(true)
      let tempQuery = this.getChangeAuditStageParam()
      let query = {
        beginTime: this.conditions.beginTime,
        endTime: this.conditions.endTime,
        siteDeviceId: tempQuery.siteDeviceId,
        stage: tempQuery.stage,
        remark: tempQuery.remark
      }

      this.$api.Audit.submit(query).then(data => {
        if (data) {
          this.$eventBus.emit(AUDIT_COMMIT)
          this.isShow = false
        }
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onBackAuditedBtnClick () {
      this.$confirm(`此操作退回当前已审核的仪器, 是否继续？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'confirm-dialog-confirm-btn',
        cancelButtonClass: 'confirm-dialog-cancel-btn',
        type: 'warning'
      }).then(() => {
        this.changeLoadStatus(true)

        this.$api.Audit.backAudited(this.auditSiteDevice.auditId).then(() => {
          this.$eventBus.emit(AUDIT_COMMIT)
          this.isShow = false
          this.$eventBus.emit(SHOW_AUDIT_MAIN)
        }).catch(console.error).finally(() => {
          this.changeLoadStatus(false)
        })
      }).catch(() => {})
    }
  },
  created () {
    this.$eventBus.on(AUDIT_ITEM_CLICK, this.onAuditItemClick)
  },
  beforeDestroy () {
    this.$eventBus.off(AUDIT_ITEM_CLICK, this.onAuditItemClick)
  }
}



// WEBPACK FOOTER //
// ./src/views/02Data-Audit/01Manual/BaseAuditDevice.js